var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"content-links"},_vm._l((_vm.data),function(link){return _c('li',{key:link.href},[_c('a',{attrs:{"href":'#' + link.href},domProps:{"textContent":_vm._s(link.title)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }